const normalizeText = (value?: string | null) => value?.trim() || '';

export const isUntouchedHardDataText = (
	persistedValue: string | null | undefined,
	currentValue: string,
	hardDataValue: string | null | undefined,
): boolean => {
	const normalizedHardData = normalizeText(hardDataValue);

	return !normalizeText(persistedValue) && Boolean(normalizedHardData) && normalizeText(currentValue) === normalizedHardData;
};

export const areUntouchedHardDataSelections = (
	persistedIds: Array<string | number>,
	currentIds: string[],
	hardDataIds: string[],
): boolean => {
	if (persistedIds.length || !hardDataIds.length || currentIds.length !== hardDataIds.length) return false;

	const current = new Set(currentIds.map(String));

	return hardDataIds.every((id) => current.has(String(id)));
};
